/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Box, Button } from "@mui/material";
import { getPasswordRecoveries } from "../../../../../api/apiCall";
import { useAuth } from "../../../../../auth/auth";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faX } from "@fortawesome/free-solid-svg-icons";
import Loading from "../../../../../components/Loading/Loading";
import AccessForbidden from "../../../../Access/AccessForbidden";

const PasswordRecovery = () => {
  const { state } = useAuth();
  const [workers, setWorkers] = useState<any[]>([]);
  const [accessForbidden, setAccessForbidden] = useState(false);
  const [loadingPage, setLoadingPage] = useState(true);

  const getWorkers = async () => {
    try {
      const response: any = await getPasswordRecoveries(state.user?.token);

      if (response === 403) {
        setAccessForbidden(true);
        return;
      }

      setWorkers(response?.data || []);
    } catch (error) {
      console.error("Failed to load password recoveries:", error);
    } finally {
      setLoadingPage(false);
    }
  };

  const handleClick = (userId: number) => {
    const url = `/pace-team/resourcing/dashboard/profile-data?userId=${userId}`;
    window.open(url, "_blank");
  };

  const columns: any = [
    {
      field: "fullName",
      headerName: "Full Name",
      flex: 1.3,
      renderCell: (params: any) => (
        <div
          onClick={() => handleClick(params.row.userId)}
          style={{ cursor: "pointer" }}
        >
          {params.row.fullName}
        </div>
      ),
    },
    {
      field: "username",
      headerName: "Username",
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "pts",
      headerName: "PTS",
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "email",
      headerName: "Email",
      flex: 1.3,
    },
    {
      field: "recovered",
      headerName: "Recovered",
      flex: 1,
      headerAlign: "center",
      align: "center",
      renderCell: (params: any) => (
        <>
          {params.row.recovered ? (
            <FontAwesomeIcon icon={faCheck} size="lg" color="green" />
          ) : (
            <FontAwesomeIcon icon={faX} size="lg" color="red" />
          )}
        </>
      ),
    },
    {
      field: "details",
      headerName: "Details",
      flex: 1,
      align: "center",
      headerAlign: "center",
      renderCell: (params: any) => (
        <Button
          variant="contained"
          onClick={() => handleClick(params.row.userId)}
          sx={{
            boxShadow: "none",
            backgroundColor: "#6c757d",
            "&:hover": {
              backgroundColor: "#5c636a",
            },
          }}
        >
          Details
        </Button>
      ),
    },
  ];

  useEffect(() => {
    getWorkers();
  }, []);

  if (loadingPage) {
    return <Loading />;
  }

  if (accessForbidden) {
    return <AccessForbidden />;
  }

  return (
    <Box sx={{ height: 730, width: "90%", margin: "4rem auto" }}>
      <DataGrid
        rows={workers}
        getRowId={(row) => row.userId}
        columns={columns}
        disableRowSelectionOnClick
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 100,
            },
          },
        }}
        pageSizeOptions={[100]}
        sx={{
          "& .MuiDataGrid-columnHeaderTitle": {
            fontWeight: "bold",
            fontSize: 15,
          },
          "& .MuiDataGrid-columnHeader": {
            backgroundColor: "#f0f0f0",
            color: "#000",
            fontWeight: "bold",
          },
          "& .disable-columns": {
            borderRight: "1px solid #bfbfbf",
          },
          "& .border-left": {
            borderLeft: "1px solid #bfbfbf",
          },
        }}
      />
    </Box>
  );
};

export default PasswordRecovery;
